import { IColor, makeColorComponent } from '@engoo/realtime-protocol/util/color';
import { Record } from 'immutable';

export const BLACK: IColor = {
  red:   makeColorComponent(0),
  green: makeColorComponent(0),
  blue:  makeColorComponent(0),
  alpha: makeColorComponent(255),
};

export class Color extends Record<IColor>(BLACK) {}
